import type { ValidationGate } from '@/services/api/schemas'

export const SAMPLE_SCHEMAS: Array<{ label: string; description: string; schema: unknown }> = [
  {
    label: 'Clean schema',
    description: 'PhoneNumber + trackable Person + anchor Location with full anchor markers',
    schema: {
      entity_types: [
        {
          label: 'Person',
          trackable: true,
          properties: [
            { name: 'name', type: 'STRING', is_display_name: true },
            { name: 'dob', type: 'DATE' },
          ],
        },
        {
          label: 'PhoneNumber',
          properties: [
            { name: 'number', type: 'STRING', is_display_name: true },
            { name: 'carrier', type: 'STRING' },
          ],
        },
        {
          label: 'Location',
          is_anchor: true,
          properties: [
            { name: 'lat', type: 'FLOAT' },
            { name: 'lon', type: 'FLOAT' },
          ],
        },
      ],
      relationship_types: [
        {
          label: 'OBSERVED_AT',
          properties: [{ name: 'observed_at', type: 'ZONED_DATETIME', is_temporal_anchor: true }],
        },
      ],
      patterns: [
        { source_type: 'Person', relationship_type: 'OBSERVED_AT', target_type: 'Location' },
      ],
    },
  },
  {
    label: 'Missing Person',
    description: 'Hard error — every schema must contain Person',
    schema: {
      entity_types: [
        {
          label: 'Individual',
          properties: [{ name: 'name', type: 'STRING' }],
        },
      ],
    },
  },
  {
    label: 'Trackable with no waypoint',
    description: 'Person opts into movement timeline but has no qualifying OUT relation',
    schema: {
      entity_types: [
        {
          label: 'Person',
          trackable: true,
          properties: [{ name: 'name', type: 'STRING', is_display_name: true }],
        },
      ],
      relationship_types: [],
      patterns: [],
    },
  },
  {
    label: 'Half-pair geo + interval-shaped misnamed',
    description: 'lat without lon, plus start_date/end_date that should be effective_from/_to',
    schema: {
      entity_types: [
        {
          label: 'Person',
          properties: [{ name: 'name', type: 'STRING', is_display_name: true }],
        },
        {
          label: 'Address',
          properties: [{ name: 'lat', type: 'FLOAT' }],
        },
        {
          label: 'Employment',
          properties: [
            { name: 'start_date', type: 'DATE' },
            { name: 'end_date', type: 'DATE' },
          ],
        },
      ],
    },
  },
  {
    label: 'Ambiguous display + temporal markers',
    description: 'Two display-name markers on Person, two is_temporal_anchor on OBSERVED_AT',
    schema: {
      entity_types: [
        {
          label: 'Person',
          properties: [
            { name: 'first_name', type: 'STRING', is_display_name: true },
            { name: 'last_name', type: 'STRING', is_display_name: true },
          ],
        },
      ],
      relationship_types: [
        {
          label: 'OBSERVED_AT',
          properties: [
            { name: 'started_at', type: 'DATETIME', is_temporal_anchor: true },
            { name: 'ended_at', type: 'DATETIME', is_temporal_anchor: true },
          ],
        },
      ],
    },
  },
]

export const GATE_OPTIONS: Array<{
  value: ValidationGate | 'all'
  label: string
  description: string
}> = [
  { value: 'all', label: 'All findings', description: 'Errors, warnings and hints' },
  {
    value: 'save_draft',
    label: 'Save draft gate',
    description: 'Nothing blocks; surfaces everything',
  },
  {
    value: 'activate_for_extraction',
    label: 'Activate gate',
    description: 'Only findings that would block activation (errors)',
  },
]

export function formatJson(value: unknown): string {
  return JSON.stringify(value, null, 2)
}
